import { didShowBanner } from 'actions/appAdvertisement';
import { userAgentStringToPlatform } from 'helpers/UserAgentUtils';
import marketplace from 'cfg/marketplace.json';

const createAppAdvertisement = (store, branchInstance = window.branch, navObject = window.navigator, marketplaceConfig = marketplace) => {
  const { domain, branchAppKey, nativeApps : { ad, platforms } } = marketplaceConfig;
  const { cookies: { hideBranchAd } } = store.getState();
  const platformName = userAgentStringToPlatform(navObject.userAgent);
  const platformExists = platforms?.[platformName];

  if (branchInstance !== undefined && ad.enabled && platformExists && !hideBranchAd) {
    branchInstance.addListener('didShowBanner', () => void store.dispatch(didShowBanner(true)));
    branchInstance.addListener('didCloseBanner', () => void store.dispatch(didShowBanner(false)));
    branchInstance.init(branchAppKey, () => {
      branchInstance.banner({
        icon: require(`../images/${domain}-app-icon.png`),
        title: ad.header.replace('{platform}', platformName),
        description: ad.tagLine.replace('{platform}', platformName),
        showiOS: ad.showiOSBranchAd,
        showiPad: ad.showiOSBranchAd,
        showAndroid: ad.showAndroidBranchAd,
        forgetHide: ad.hideDays,
        downloadAppButtonText: 'Download',
        openAppButtonText: 'Open in app',
        iframe: false,
        showDesktop: false,
        showKindle: false,
        showBlackberry: false,
        showWindowsPhone: false,
        disableHide: false
      });
    });
  }
};
export default createAppAdvertisement;
